import handlers from './handlers';
import actions, { PREFIX } from './actions';

const reset = (orm, action) => {
  // TODO: Use single source of thruth for [key, Model]?
  const keys = [
    ['genders', 'Gender'],
    ['lifts', 'Lift'],
    ['bodyweightCategories', 'BodyweightCategory'],
    ['ageGroups', 'AgeGroup'],
    ['events', 'Event'],
    ['contests', 'Contest'],
    ['teams', 'Team'],
    ['entries', 'Entry'],
    ['lots', 'Lot'],
    ['groups', 'Group'],
    ['sessions', 'Session'],
    ['weighInDatums', 'WeighInDatum'],
    ['weighInDeclarations', 'WeighInDeclaration'],
    ['protocols', 'Protocol'],
    ['athletes', 'Athlete'],
    ['declarations', 'Declaration'],
    ['attempts', 'Attempt'],
    ['decisions', 'Decision'],
  ];

  const session = orm.session(orm.getEmptyState());

  for (const [key, modelName] of keys) {
    const { [modelName]: Model } = session;
    const { [key]: records = [] } = action.payload;
    for (const record of records) Model.create(record, { parse: true });
  }

  return session.state;
};

const createReducer = orm => (state, action) => {
  if (!action.type.startsWith(PREFIX) && state) return state;

  // TODO: Pass orm.getEmptyState() in meta to handlers?
  if (action.type === String(actions.reset)) return reset(orm, action);

  const session = orm.session(state);

  const handler = handlers[action.type];
  if (handler) {
    handler(state, action, session);
  } else {
    if (state && process.env.NODE_ENV !== 'production')
      console.warn(
        'Unhandled ORM action "%s"',
        action.type,
        //action.payload,
      );
  }

  return session.state;
};

export default createReducer;



// WEBPACK FOOTER //
// ./src/orm/reducer.js